export const moderatorMailWhiteList = ['@nntest.de'];
